import { MAX_WORKOUT_NOTE_LENGTH } from "../../../utils/section-types";
import SvgIcon from "../../SvgIcon";

/**
 * Collapsible "Instructions (Optional)" row in the workout-queue header.
 * Mirrors the collapsible pattern in
 * add_edit_exercise/components/ExerciseLibraryMetadataGapsNotice.js: a
 * chevron-button summary and a panel toggled with a `hidden` class rather
 * than unmounted, so the textarea keeps its DOM state (text, caret, scroll)
 * across re-renders — important here because `.wq-list` below is remounted
 * on every drag drop (see WorkoutQueuePanel's resyncKey), but `.wq-head`
 * (where this row lives) is not.
 *
 * `value`/`onChange` are the queue's single note draft; the note itself is
 * created/updated server-side as part of the queue save (save-workout-queue),
 * never as its own request.
 */
function WorkoutQueueNoteRow({ value, expanded, onToggle, onChange, t }) {
  return (
    <div className="wq-note">
      <button
        type="button"
        className="wq-note-summary"
        aria-expanded={expanded}
        onClick={onToggle}
      >
        <span className="wq-note-title">
          <SvgIcon
            src="/img/new-icons/clipboard-notes.svg"
            classNames="workout-note__icon"
          />
          {t("workoutQueue.workoutNote")}{" "}
          <span className="wq-note-title-optional">
            {t("workoutQueue.optional")}
          </span>
        </span>
        {!expanded && value && <span className="wq-note-preview">{value}</span>}
        {!expanded && !value ? (
          <button
            className="wq-note-add-button"
            type="button"
            data-button-type="secondary"
          >
            {t("workoutQueue.addWorkoutNote")}
          </button>
        ) : (
          <SvgIcon
            src="/img/svg/angle-right.svg"
            classNames={`wq-note-chevron ml-auto${expanded ? " wq-note-chevron--open" : ""}`}
          />
        )}
      </button>
      <div
        className={expanded ? "wq-note-panel" : "wq-note-panel hidden"}
        aria-hidden={!expanded}
      >
        <textarea
          className="text-input wq-note-input"
          value={value}
          maxLength={MAX_WORKOUT_NOTE_LENGTH}
          placeholder={t("workoutQueue.workoutNotePlaceholder")}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}

export default WorkoutQueueNoteRow;
